export default "__VITE_ASSET__hgSfH3wu__"